import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="bg-white section-padding-top">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 items-stretch">

          <div className="text-center lg:text-left col-span-3 flex flex-col justify-center">
            <span className="text-accent font-medium mb-4 block">98% satisfaction</span>
            <h1 className="heading-xl mb-6 bg-gradient-to-r from-indigo-600 via-purple-600 to-violet-500 bg-clip-text text-transparent">
              Formez vos équipes et<span className="text-black"> déployez l’IA </span> facilement
            </h1>
            <p className="text-xl text-gray-500 mb-8">
              Formations IA, agents IA, automatisation, ateliers métiers et accompagnement opérationnel pour PME et ETI.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Link to="/formation-ia-entreprise/" className="btn-primary">
                Découvrir nos formations
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
              <Link to="/demarrer-votre-diagnostic-ia-entreprise/" className="btn-secondary">
                Faire mon diagnostic gratuit
              </Link>
            </div>
          </div>

          <div className="relative col-span-2 flex items-stretch">
            <div className="relative w-full h-full max-h-[400px] mx-auto">
              <img
                src="/seminairecut.webp"
                alt="Cyril Cohen Solal - Formation IA"
                className="rounded-xl object-cover w-full h-full"
                width="1200"
                height="800"
                loading="eager"
                decoding="async"
                fetchPriority="high"
              />
              <div className="absolute inset-0 rounded-xl"></div>
              <div className="absolute bottom-2 left-2 bg-white p-2 rounded-lg shadow-xl">
                <div className="flex items-center space-x-2">
                  <div className="bg-primary rounded-full p-1.5">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                  </div>
                  <div>
                    <p className="text-xs font-medium text-gray-800">Cyril Cohen Solal - Expert Data & IA</p>
                    <p className="text-[10px] text-gray-500">+1300 professionnels formés</p>
                    <p className="text-[10px] text-gray-500">98% satisfaction</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
